import { MDSText } from "@/mds/components/text";
import styled from "@emotion/styled";

export const StyledSessionWrapper = styled.div`
  position: relative;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.x100};
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  &:last-child {
    margin-bottom: ${({ theme }) => `-${theme.spacing.sm}`};
  }
`;

export const StyledSessionTitle = styled(MDSText)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  padding: ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.sm}
    ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.sm};
  margin: 0;
  max-width: 100%;
`;

export const StyledTitleAndStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  min-width: 0; /* Allow flex items to shrink below content size */
  padding-top: ${({ theme }) => `${theme.spacing.md}`};
  padding-left: ${({ theme }) => `${theme.spacing.md}`};
  padding-right: ${({ theme }) => `${theme.spacing.md}`};
  padding-bottom: ${({ theme }) => `${theme.spacing.sm}`};
  max-width: 100%;
`;

export const StyledTitleText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  max-width: 100%;
  min-width: 0; /* Allow the text to shrink */
  color: ${({ theme }) => theme.colors.text.contrast};
`;

export const StyledSubtitleText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  text-align: left;
  padding: 0 ${({ theme }) => `${theme.spacing.md}`} ${({ theme }) => `${theme.spacing.sm}`};
  max-width: 100%;
  min-width: 0; /* Allow the text to shrink */
`;

export const StyledSessionBody = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
`;

export const StyledMessagesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledReasoningMessage = styled.div`
  color: ${({ theme }) => theme.colors.chat.header};
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const StyledActionMessage = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.colors.grey.x875};
  font-size: ${({ theme }) => theme.fontSizes.smedium};
  line-height: ${({ theme }) => theme.lineHeights.smedium};
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  a {
    color: ${({ theme }) => theme.colors.grey.x875};
    text-decoration: underline;
  }
`;

export const StyledSessionIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const StyledDebugContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsPlus};
  font-size: ${({ theme }) => theme.fontSizes.xxxxsmall};
  color: ${({ theme }) => theme.colors.grey.x300};
  cursor: pointer;
`;

export const StyledDebugSessionId = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing.xsPlus};
  padding-right: ${({ theme }) => theme.spacing.xsPlus};
  border-radius: ${({ theme }) => theme.borderRadius.medium};

  &:active {
    color: ${({ theme }) => theme.colors.grey.x400};
    background-color: ${({ theme }) => theme.colors.grey.x25};
  }
`;
